import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  fruitBaskets,
  getProduct,
  images,
  initialAddresses,
  products,
  serviceAreas,
  shakeProducts,
  timeSlots,
  weekdays,
} from "../data";
import { useApp } from "../store";
import {
  AddressCard,
  Brand,
  DeliveryCard,
  EmptyState,
  PageHeader,
  PrimaryButton,
  ProductCard,
  StatusBadge,
} from "../components/UI";

import "../css/Deliveries.css";
export function Deliveries() {
  const { deliveries } = useApp();
  const [tab, setTab] = useState("Upcoming");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const visible =
    tab === "Completed"
      ? deliveries.filter((d) => d.status === "Delivered")
      : tab === "Cancelled"
        ? deliveries.filter((d) => ["Cancelled", "Skipped"].includes(d.status))
        : tab === "Active"
          ? deliveries.filter(
              (d) =>
                d.recurring && !["Cancelled", "Skipped"].includes(d.status),
            )
          : deliveries.filter(
              (d) => !["Delivered", "Cancelled", "Skipped"].includes(d.status),
            );
  return (
    <div className="page-wrap container-xl">
      <PageHeader
        title="My deliveries"
        copy="Your schedules, upcoming drops and delivery history in one place."
      />
      <div className="tabs">
        {["Upcoming", "Active", "Completed", "Cancelled"].map((t) => (
          <button
            key={t}
            className={tab === t ? "active" : ""}
            onClick={() => setTab(t)}
          >
            {t}
          </button>
        ))}
      </div>
      <div className="delivery-list">
        {visible.length ? (
          visible.map((d) => <DeliveryCard key={d.id} delivery={d} />)
        ) : (
          <EmptyState
            title={`No ${tab.toLowerCase()} deliveries`}
            copy="Nothing to show here right now."
          />
        )}
      </div>
    </div>
  );
}

export default Deliveries;
